import { NgClass } from '@angular/common'
import { Component, Input } from '@angular/core'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'

@Component({
  selector: 'otto-helper',
  standalone: true,
  imports: [E11TooltipModule, NgClass],
  template: `
    <e11-tooltip [color]="'dark-grey'" [tooltipText]="tooltipText" [hideTooltip]="hideTooltip">
      <span class="material-symbols-outlined e11-text-skin-complimentary" [ngClass]="{ 'e11-text-base': small }"> robot_2 </span>
    </e11-tooltip>
  `,
})
export class OttoHelperComponent {
  @Input() tooltipText: string = ''
  @Input() hideTooltip: boolean = false
  @Input() small: boolean = false
}
